<template>
	<!-- 监考详情-记录监考信息 -->
	<el-dialog :title="remarkTextConfig.title" v-if="dialogVisible" :visible.sync="dialogVisible" width="470px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
		<el-form :model="form" ref="form">
			<div style="font-weight: bold; margin-bottom: 10px;">{{remarkTextConfig.remarkTitle}}</div>

			<!-- 文本输入框 -->
			<el-form-item prop="content">
				<el-input
						type="textarea"
						:rows="8"
						v-model="form.remark"
						maxlength="200"
						show-word-limit
						resize="none"
				></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
            <el-button @click="close">{{ remarkTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="submitForm()">{{ remarkTextConfig.ok }}</el-button>
        </span>
	</el-dialog>
</template>

<script>
    import {putRemark} from "@/api/invigilate";

    export default {
        props: ['row', 'show'],
        data() {
            return {
                dialogVisible: false,
                form: {
                    id: null,
                    remark: '',
                },
                cheatLabel: '',
                invalidLabel: ''
            };
        },
        computed: {
            remarkTextConfig() {
                return this.$store.state.global.textConfig.backend.invigilateDetail.remark
            },
        },
        watch: {
            show() {
                this.dialogVisible = this.show;
            },
            row() {
                if (this.row) {
                    this.form.id = this.row.id
                    this.form.remark = this.row.remark
                }
            }
        },
        methods: {
            close() {
                this.dialogVisible = false
                this.form.examStatus = 2
                this.$emit('close', false)
            },
            submitForm() {
                putRemark(this.form).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功！'
                        });
                        this.$parent.search(1)
                    }
                })
                this.close()
            }
        }
    }
</script>

<style scoped>

</style>
